import React from 'react';
import { Modal } from '../../../../components/containers/Modal';
import { BoxNotification } from '../../../../components/containers/BoxNotification';
import { ButtonColorsEnum } from '../../../../constants/button-colors';

export type DeleteConfirmationModalViewProps = {
  onCloseHandler: () => void;
  onConfirmationHandler: CallableFunction;
};

export const DeleteConfirmationModalView = (props: DeleteConfirmationModalViewProps): JSX.Element => {
  return (
    <Modal
      onClose={props.onCloseHandler}
      closeOnClickOutside={false}
      showCloseIcon={true}
      title={'Delete Media?'}
      primaryButtonAction={() => {
        props.onCloseHandler();
        props.onConfirmationHandler();
      }}
      primaryButtonTitle={'Delete Media'}
      primaryButtonColor={ButtonColorsEnum.alert}>
      <p>Are you sure you want to remove the selected media from your Media Library?</p>
      <BoxNotification type={'info'}>
        Any Posts that use the media won&apos;t be affected.
      </BoxNotification>
    </Modal>
  );
};
